const getAnchor = (text) => text.toLowerCase().replace(/[^\w]+/g, '-');

export default getAnchor;
